/**
 * Class which includes HTML elements we expect to be in page for JS use.
 */
export class UserInterfaceHtmlElements {

    public isSearchRunning: boolean = false;

    public readonly camerasContainer:    HTMLDivElement   = document.querySelector('#tabkamery') as HTMLDivElement;
    public readonly searchInputField:    HTMLInputElement = document.querySelector('#tabkamery #snih-search') as HTMLInputElement;
    public readonly iconMagnifyingGlass: HTMLImageElement = document.querySelector('#tabkamery #snih-search-img') as HTMLImageElement;
    public readonly iconSpinner:         HTMLImageElement = document.querySelector('#tabkamery img.search_spinner.search_ico') as HTMLImageElement;

    public getSearchQuery(): string {
        return this.searchInputField.value.trim();
    }

    public showSpinnerIcon(): void {
        this.iconMagnifyingGlass.style.display = 'none';
        this.iconSpinner.style.display = 'block';
    }

    public showMagnifyingGlassIcon(): void {
        this.iconSpinner.style.display = 'none';
        this.iconMagnifyingGlass.style.display = 'block';
    }

    public showContentCamerasTables(): void {
        this.camerasContainer
            .querySelectorAll('table')
            .forEach((element: HTMLTableElement) => {

                element.style.display = 'table';
            });
    }

    public hideContentCamerasTables(): void {
        this.camerasContainer
            .querySelectorAll('table')
            .forEach((element: HTMLTableElement) => {

                element.style.display = 'none';
            });
    }

    public removeSearchedCamerasTable(): void {
        let brAfterTable = this.camerasContainer.querySelector('#tabkameryfiltr + br');
        if (brAfterTable instanceof HTMLElement) {
            brAfterTable.remove();
        }

        let searchedCamerasTable = this.camerasContainer.querySelector('#tabkameryfiltr');
        if (searchedCamerasTable instanceof HTMLElement) {
            searchedCamerasTable.remove();
        }
    }

    public swapCamerasTableForSearchResultCamerasTable(promiseOfSearchedCamerasTableHTml: Promise<any>): void {
        promiseOfSearchedCamerasTableHTml
            .then(response => response.json())
            .then(tableHtml => {
                this.hideContentCamerasTables();

                // Add <div id="tabkameryfiltr">...</div>.
                this.camerasContainer.insertAdjacentHTML('beforeend', tableHtml);

                (this.camerasContainer.querySelector('#btn-na-puvodni') as HTMLSpanElement)
                    .addEventListener('click', () => {
                        this.searchInputField.disabled = false;
                        this.searchInputField.value    = '';
                        this.removeSearchedCamerasTable();
                        this.showMagnifyingGlassIcon();
                        this.showContentCamerasTables();
                    });
            })
            .catch(() => {
                console.log('Searching failed.');
            })
            .finally(() => {
                this.isSearchRunning = false;
            });
    }
}